import React from "react"
import { useDispatch } from "react-redux"
import IAMAction from "../../actions/IAMAction"
import { Dialog, DialogContent, DialogTitle, Typography } from "@material-ui/core"

const SEC = 1000
const MIN = 60 * SEC
const WARNING_TIMEOUT = 10
const LOGOUT_TIMEOUT = 5

const SessionTimeoutWrapper = ({ children }) => {
    const [warning, setWarning] = React.useState(false)
    const [logout, setLogout] = React.useState(false)
    const [countdown, setCountdown] = React.useState(LOGOUT_TIMEOUT * MIN / SEC)
    const timeout = WARNING_TIMEOUT * MIN
    const dispatch = useDispatch()

    const events = ["click", "scroll", "load", "keydown", "keypress"]

    React.useEffect(() => {
        let timeoutId
        let warningTimeoutId
        let logoutCountdownId

        const startCountdown = () => {
            logoutCountdownId = setInterval(() => {
                setCountdown((current) => { return current - 1 })
            }, 1000)
        }

        const resetTimeout = () => {
            clearTimeout(timeoutId)
            clearTimeout(warningTimeoutId)
            clearInterval(logoutCountdownId)
            setCountdown(LOGOUT_TIMEOUT * MIN / SEC)

            console.log("Session Timeout Wrapper::Start")
            timeoutId = setTimeout(() => {
                console.log("Session Timeout Wrapper::Warning")
                setWarning(true)
                startCountdown()
                warningTimeoutId = setTimeout(() => {
                    console.log("Session Timeout Wrapper::Logout")
                    setLogout(true)
                }, LOGOUT_TIMEOUT * MIN)
            }, timeout)
        }

        const clearSessionTimeout = () => {
            clearTimeout(timeoutId)
            clearTimeout(warningTimeoutId)
            clearInterval(logoutCountdownId)
        }

        const handlerUserActivity = () => {
            setWarning(false)
            resetTimeout()
        }

        events.forEach(eventName => document.addEventListener(eventName, handlerUserActivity))

        resetTimeout()

        return () => {
            events.forEach(eventName => document.removeEventListener(eventName, handlerUserActivity))
            clearSessionTimeout()
            console.log("Session Timeout Wrapper::End")
        }
    }, [])

    React.useEffect(() => {
        if (logout) {
            IAMAction.logout(dispatch)
        }
    }, [logout])

    const parseCountdown = () => {
        var min = Math.floor(countdown / (MIN / SEC))
        var sec = Math.floor(countdown % (MIN / SEC))
        return String(min) + ":" + (sec > 9 ? "" : "0") + String(sec)
    }

    return (
        <React.Fragment>
            {children}
            <Dialog open={warning} maxWidth="sm">
                <DialogTitle disableTypography><Typography variant='h3' color='textSecondary'>Warning</Typography></DialogTitle>
                <DialogContent>
                    <Typography variant='h5' color='textSecondary'>You will be logged out in {parseCountdown()} due to inactivity.</Typography>
                    <Typography variant='h5' color='textSecondary'>Press any key or Click any where to remain logged in.</Typography>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default SessionTimeoutWrapper
